import moment from 'moment';
import * as React from 'react';
import { useQuery } from '@tanstack/react-query';
import {
  SegmentAttributeDatetime,
  SegmentAttributeDetailResponse,
  SegmentAttributeOptions,
  SegmentAttributeRange,
  SegmentAttributeTransactional
} from '../models/segments';
import { AppContext, AppProviderDispatch } from '../shared/app-context';
import useRestService from '../shared/rest-service';
import { transactionalAttributeIdOffset } from '../utilities/attribute-filter';

export function useSegmentAttributeDetails(attributeId: number, enabled: boolean, isTransactional: boolean) {
  const appState = React.useContext<AppProviderDispatch>(AppContext);
  const { fetchWrapper } = useRestService();
  const normalizedId: number = !isTransactional
    ? attributeId
    : attributeId - transactionalAttributeIdOffset < 0
    ? attributeId
    : attributeId - transactionalAttributeIdOffset;
  const fetchURL = isTransactional
    ? `api/${appState.state.clientId}/attributes/transactional/${normalizedId}`
    : `api/${appState.state.clientId}/attributes/${normalizedId}`;

  return useQuery<
    SegmentAttributeDetailResponse,
    Error,
    SegmentAttributeOptions | SegmentAttributeRange | SegmentAttributeDatetime | SegmentAttributeTransactional
  >(
    ['segment-attribute-details', appState.state.clientId, attributeId],
    async () => {
      return fetchWrapper(fetchURL);
    },
    {
      select: (data) => {
        const filters = data.filters ? JSON.parse(data.filters) : [];
        if (data.filterType === 'datetime') {
          return { ...data, filters: { ...filters, min: moment(filters.min), max: moment(filters.max) } };
        }
        return {
          ...data,
          filters
        };
      },
      enabled
    }
  );
}
